const InitialLoader = () => (
  <div
    style={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      minHeight: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
    <svg width={300} height={120} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 587.06 129.91">
      <title>agileone_header_logo_color</title>
      <path
        fill="#ea9549"
        d="M65,129.91a65,65,0,1,1,65-65A65,65,0,0,1,65,129.91ZM65,18.83A46.12,46.12,0,1,0,111.08,65,46.17,46.17,0,0,0,65,18.83Z"
      />
      <path
        fill="#ea9549"
        d="M77.94,49.55a1.3,1.3,0,0,1,1.82,1.53l-4.4,15.38L70.9,82a1.61,1.61,0,0,1-3.08.07L64.53,67.21,49.41,66.5A1.62,1.62,0,0,1,49,63.44l15.25-7.31Z"
      />
      <path fill="#ea9549" d="M193.4,27.07h12.78l27,63.45H218.69l-5.76-14.13H186.29l-5.76,14.13H166.4ZM208,64.15l-8.37-20.43-8.37,20.43Z" />
      <path
        fill="#ea9549"
        d="M239.49,100.05l4.68-10.26a31.48,31.48,0,0,0,16.29,4.41c9.36,0,13.77-4.5,13.77-13.14V78.73c-4,4.86-8.46,7.83-15.75,7.83-11.25,0-21.42-8.19-21.42-22.5v-.18c0-14.4,10.35-22.5,21.42-22.5,7.47,0,11.88,3.15,15.57,7.2v-6.3h13.68V79.62c0,8.64-2.07,14.94-6.12,19-4.5,4.5-11.43,6.48-20.79,6.48A45.78,45.78,0,0,1,239.49,100.05Zm34.74-36v-.18c0-6.57-5.13-11.16-11.79-11.16s-11.7,4.59-11.7,11.16v.18c0,6.66,5,11.16,11.7,11.16S274.23,70.62,274.23,64.06Z"
      />
      <path fill="#ea9549" d="M300.24,24.82h14.4V37h-14.4Zm.36,17.46h13.68V90.51H300.6Z" />
      <path fill="#ea9549" d="M327.78,24.82h13.68v65.7H327.78Z" />
      <path
        fill="#ea9549"
        d="M352,66.67v-.18c0-13.77,9.81-25.11,23.85-25.11,16.11,0,23.49,12.51,23.49,26.19,0,1.08-.09,2.34-.18,3.6H365.58c1.35,6.21,5.67,9.45,11.79,9.45,4.59,0,7.92-1.44,11.7-5l7.83,6.93c-4.5,5.58-11,9-19.71,9C362.7,91.59,352,81.42,352,66.67Zm34-4c-.81-6.12-4.41-10.26-10.17-10.26s-9.36,4-10.44,10.26Z"
      />
      <path
        fill="#ea9549"
        d="M408.15,59.2V59c0-17.91,14.13-32.58,33.57-32.58s33.39,14.49,33.39,32.4V59c0,17.91-14.13,32.58-33.57,32.58S408.15,77.1,408.15,59.2Zm52.47,0V59c0-10.8-7.92-19.8-19.08-19.8s-18.9,8.82-18.9,19.62V59c0,10.8,7.92,19.8,19.08,19.8S460.61,70,460.61,59.2Z"
      />
      <path
        fill="#ea9549"
        d="M486,42.28h13.68v6.84c3.15-4,7.2-7.74,14.13-7.74,10.35,0,16.38,6.84,16.38,17.91V90.51H516.5V63.6c0-6.48-3.06-9.81-8.28-9.81s-8.55,3.33-8.55,9.81V90.51H486Z"
      />
      <path
        fill="#ea9549"
        d="M539.72,66.67v-.18c0-13.77,9.81-25.11,23.85-25.11,16.11,0,23.49,12.51,23.49,26.19,0,1.08-.09,2.34-.18,3.6H553.31c1.35,6.21,5.67,9.45,11.79,9.45,4.59,0,7.92-1.44,11.7-5l7.83,6.93c-4.5,5.58-11,9-19.71,9C550.43,91.59,539.72,81.42,539.72,66.67Zm34-4c-.81-6.12-4.41-10.26-10.17-10.26s-9.36,4-10.44,10.26Z"
      />
    </svg>
  </div>
);

export default InitialLoader;
